import {
    ChevronRight,
} from "lucide-react";
import RecommendationProductCard from "../RecommendationProductCard";
import {
    getCategoryDisplayName,
    getRecommendationProducts,
} from "../RecommendationProductsData";
import "./CategoryBestSellersSection.css";

type CategoryBestSellersSectionProps = {
    category?: string;
};

const CategoryBestSellersSection = ({
    category,
}: CategoryBestSellersSectionProps) => {
    const products =
        getRecommendationProducts(
            category,
            "bestSellers"
        );

    const categoryName =
        getCategoryDisplayName(
            category
        );

    return (
        <section className="category-best-sellers">
            <div className="category-best-sellers-container">
                <div className="category-best-sellers-header">
                    <div>
                        <span>
                            SHOPPER FAVOURITES
                        </span>

                        <h2>
                            Best Sellers in{" "}
                            {
                                categoryName
                            }
                        </h2>

                        <p>
                            Highly rated products with strong customer interest, repeat purchases and consistent reviews.
                        </p>
                    </div>

                    <button type="button">
                        View best sellers

                        <ChevronRight
                            size={16}
                        />
                    </button>
                </div>

                <div className="category-best-sellers-grid">
                    {products.map(
                        (
                            product
                        ) => (
                            <RecommendationProductCard
                                key={
                                    product.id
                                }
                                product={
                                    product
                                }
                            />
                        )
                    )}
                </div>
            </div>
        </section>
    );
};

export default CategoryBestSellersSection;